var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "billing-address-form" },
    [
      _c("div", { staticClass: "container" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form" },
          [
            _vm.form.isCompany
              ? _c(
                  "div",
                  { staticClass: "column" },
                  [
                    _c("Input", {
                      attrs: { placeHolder: "John", title: "Şirket Adı" },
                      model: {
                        value: _vm.form.name,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "name", $$v)
                        },
                        expression: "form.name",
                      },
                    }),
                  ],
                  1
                )
              : _c(
                  "div",
                  { staticClass: "column" },
                  [
                    _c("Input", {
                      attrs: { placeHolder: "John", title: "Adı" },
                      model: {
                        value: _vm.form.name,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "name", $$v)
                        },
                        expression: "form.name",
                      },
                    }),
                    _vm._v(" "),
                    _c("Input", {
                      attrs: { placeHolder: "Doe", title: "Soyadı" },
                      model: {
                        value: _vm.form.surname,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "surname", $$v)
                        },
                        expression: "form.surname",
                      },
                    }),
                  ],
                  1
                ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "column" },
              [
                !_vm.form.isCompany
                  ? _c("Input", {
                      attrs: { placeHolder: "00000000000", title: "TC Kimlik" },
                      model: {
                        value: _vm.form.idenity,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "idenity", $$v)
                        },
                        expression: "form.idenity",
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("Input", {
                  attrs: {
                    placeHolder: "johndoe@supsis.com",
                    title: "E-Posta",
                  },
                  model: {
                    value: _vm.form.mail,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "mail", $$v)
                    },
                    expression: "form.mail",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _vm.form.isCompany
              ? _c(
                  "div",
                  { staticClass: "column" },
                  [
                    _c(
                      "div",
                      { attrs: { id: "input" } },
                      [
                        _vm._m(1),
                        _vm._v(" "),
                        _c("a-auto-complete", {
                          staticStyle: { width: "100%" },
                          attrs: { "data-source": _vm.taxOffices },
                          on: { search: _vm.onSearch },
                          model: {
                            value: _vm.form.taxOffice,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "taxOffice", $$v)
                            },
                            expression: "form.taxOffice",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("Input", {
                      attrs: {
                        placeHolder: "00000000000",
                        title: "Vergi Numarası",
                      },
                      model: {
                        value: _vm.form.taxNumber,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "taxNumber", $$v)
                        },
                        expression: "form.taxNumber",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "column" },
              [
                _c("Input", {
                  attrs: { placeHolder: "Türkiye", title: "Ülke" },
                  model: {
                    value: _vm.form.country,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "country", $$v)
                    },
                    expression: "form.country",
                  },
                }),
                _vm._v(" "),
                _c("Input", {
                  attrs: { placeHolder: "İstanbul", title: "Şehir" },
                  model: {
                    value: _vm.form.city,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "city", $$v)
                    },
                    expression: "form.city",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("Input", {
              attrs: { placeHolder: "TeknoPark", title: "Adress" },
              model: {
                value: _vm.form.address,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "address", $$v)
                },
                expression: "form.address",
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "billing-checkboxes" }, [
              _c(
                "div",
                { staticClass: "billing-addreses-type" },
                [
                  _c("a-input", {
                    attrs: { type: "checkbox" },
                    model: {
                      value: _vm.form.isCompany,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "isCompany", $$v)
                      },
                      expression: "form.isCompany",
                    },
                  }),
                  _vm._v(" "),
                  _c("label", [_vm._v("Şirket Faturası olarak kayıt et")]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "billing-addreses-type" },
                [
                  _c("a-input", {
                    attrs: { type: "checkbox", value: _vm.userAgreement },
                    on: {
                      change: function ($event) {
                        return _vm.$emit(
                          "userAgreementAccepted",
                          $event.target.checked
                        )
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      on: {
                        click: function () {
                          return (_vm.userAgreementModal = true)
                        },
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("message.confidentialityAgreementCheck"))
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          staticClass: "agreementModal",
          attrs: {
            height: "400px",
            title: _vm.$t("message.confidentialityAgreement"),
            visible: _vm.userAgreementModal,
          },
          on: {
            ok: function () {
              _vm.userAgreementModal = false
              _vm.userAgreement = true
            },
            cancel: function () {
              return (_vm.userAgreementModal = false)
            },
          },
        },
        [
          _c("div", { staticStyle: { height: "400px", overflow: "auto" } }, [
            _vm._v(
              "\n            Güvenliğiniz bizim için önemli. Bu sebeple bizimle paylaşacağınız kişisel verileriz hassasiyetle\n            korunmaktadır. Supsis.com, veri sorumlusu olarak, bu gizlilik ve kişisel verilerin korunması politikası\n            ile, hangi kişisel verilerinizin hangi amaçla işleneceği, işlenen verilerin kimlerle ve neden\n            paylaşılabileceği, veri işleme yöntemimiz ve hukuki sebeplerimiz ile; işlenen verilerinize ilişkin\n            haklarınızın neler olduğu hususunda sizleri aydınlatmayı amaçlıyoruz. Toplanan Kişisel Verileriniz,\n            Toplanma Yöntemi ve Hukuki Sebebi IP adresiniz ve kullanıcı aracısı bilgileriniz, sadece analiz yapmak\n            amacıyla ve çerezler (cookies) vb. teknolojiler vasıtasıyla, otomatik veya otomatik olmayan yöntemlerle\n            ve bazen de analitik sağlayıcılar, reklam ağları, arama bilgi sağlayıcıları, teknoloji sağlayıcıları\n            gibi üçüncü taraflardan elde edilerek, kaydedilerek, depolanarak ve güncellenerek, aramızdaki hizmet ve\n            sözleşme ilişkisi çerçevesinde ve süresince, meşru menfaat işleme şartına dayanılarak işlenecektir.\n            Kişisel Verilerinizin İşlenme Amacı Bizimle paylaştığınız kişisel verileriniz sadece analiz yapmak\n            suretiyle; sunduğumuz hizmetlerin gerekliliklerini en iyi şekilde yerine getirebilmek, bu hizmetlere\n            sizin tarafınızdan ulaşılabilmesini ve maksimum düzeyde faydalanılabilmesini sağlamak, hizmetlerimizi,\n            ihtiyaçlarınız doğrultusunda geliştirebilmek ve sizleri daha geniş kapsamlı hizmet sağlayıcıları ile\n            yasal çerçeveler içerisinde buluşturabilmek ve kanundan doğan zorunlulukların (kişisel verilerin talep\n            halinde adli ve idari makamlarla paylaşılması) yerine getirilebilmesi amacıyla, sözleşme ve hizmet\n            süresince, amacına uygun ve ölçülü bir şekilde işlenecek ve güncellenecektir. Toplanan Kişisel Verilerin\n            Kimlere ve Hangi Amaçlarla Aktarılabileceği Bizimle paylaştığınız kişisel verileriniz; faaliyetlerimizi\n            yürütmek üzere hizmet aldığımız ve/veya verdiğimiz, sözleşmesel ilişki içerisinde bulunduğumuz, iş\n            birliği yaptığımız, yurt içi ve yurt dışındaki 3. şahıslar ile kurum ve kuruluşlara ve talep halinde\n            adli ve idari makamlara, gerekli teknik ve idari önlemler alınması koşulu ile aktarılabilecektir.\n            Kişisel Verileri İşlenen Kişi Olarak Haklarınız KVKK madde 11 uyarınca herkes, veri sorumlusuna\n            başvurarak aşağıdaki haklarını kullanabilir: Kişisel veri işlenip işlenmediğini öğrenme, Kişisel\n            verileri işlenmişse buna ilişkin bilgi talep etme, Kişisel verilerin işlenme amacını ve bunların amacına\n            uygun kullanılıp kullanılmadığını öğrenme, Yurt içinde veya yurt dışında kişisel verilerin aktarıldığı\n            üçüncü kişileri bilme, Kişisel verilerin eksik veya yanlış işlenmiş olması hâlinde bunların\n            düzeltilmesini isteme, Kişisel verilerin silinmesini veya yok edilmesini isteme, (e) ve (f) bentleri\n            uyarınca yapılan işlemlerin, kişisel verilerin aktarıldığı üçüncü kişilere bildirilmesini isteme,\n            İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle kişinin kendisi\n            aleyhine bir sonucun ortaya çıkmasına itiraz etme, Kişisel verilerin kanuna aykırı olarak işlenmesi\n            sebebiyle zarara uğraması hâlinde zararın giderilmesini talep etme, haklarına sahiptir. Yukarıda sayılan\n            haklarınızı kullanmak üzere info@supsis.com üzerinden bizimle iletişime geçebilirsiniz. Supsis.com\n            sitesinde yer alan bütün yazılar, materyaller, resimler, ses dosyaları, animasyonlar, videolar, dizayn,\n            tasarım ve düzenlemelerimizin telif hakları 5846 numaralı yasa telif hakları korunmaktadır. Bunlar\n            Supsis.com‘un yazılı izni olmaksızın ticari olarak herhangi bir şekilde kopyalanamaz, dağıtılamaz,\n            değiştirilemez, yayınlanamaz. İzinsiz ve kaynak belirtilmeksizin kopyalama ve kullanımı yapılamaz.\n            Supsis.com’daki harici linkler ayrı bir sayfada açılır. Yayınlanan yazı ve yorumlardan şirket\n            sorumludur. Supsis.com’da hiçbir bildirim yapmadan, herhangi bir zaman değişikliğe gidebilir. Çerezler\n            Supsis.com, internet sitesinin kullanım amaçları doğrultusunda ve bunlarla sınırlı olmak üzere gerekli\n            gördüğü durumlarda kullanıcıların bilgisayarlarına “Cookie” (çerez) olarak adlandırılan ve kullanıcıyı\n            tanımlamaya yardımcı olan yazılımı yerleştirebilir. Cookie kullanımı, Supsis.com Web Sitesi\n            ziyaretlerinde ve internet üzerinde standart bir politika olarak kabul edilen uygulamadır. Kullanıcılar\n            istekleri doğrultusunda işlevsel kullanım amacıyla yerleştirilecek Cookie’leri kişisel web tarayıcı\n            ayarları sayesinde engelleyebilme haklarını saklı tutarlar.\n        "
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header" }, [
      _c("div", { staticClass: "title" }, [_vm._v("Fatura Adresi")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("label", [_vm._v("Vergi Dairesi")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }